module.exports = __webpack_public_path__ + "img/chat-button.b250d3c0.svg";